import tw, { styled } from 'twin.macro';
import ListItem from '../ListItem/ListItem';
import CollapsibleListItem from '../CollapsibleListItem/CollapsibleListItem';

/*
 *  'min-w-0': Flex hack to have the class `break-words` to work in a flex environment.
 *  'break-words': Let the textual content break in a nice way
 */
export const YPAttachmentListItem = styled(ListItem)(() => [tw`mb-8`]);

export const YPAttachmentCollapsibleListItem = styled(CollapsibleListItem)`
  svg {
    ${tw`-ml-4`}
  }
`;
